import { z } from 'zod';

import { chatUiBase } from '../../shared/schema/base.js';

/**
 * Atalho para a Carteira do app (`wallet_link`, #6278) — a recepção o emite quando o cliente
 * pede saldo (ou fala da carteira) e a Carteira é oferecida a ele. O botão despacha
 * `open-wallet` (client-side): `balance` abre o pedido de saldo, `home` a Carteira.
 */
export const WalletLinkBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('wallet_link'),
    screen: z.enum(['balance', 'home']),
  })
  .strict();
export type WalletLinkBlock = z.infer<typeof WalletLinkBlockSchema>;
